import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'zwi-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent {
  @Input() menuItems: { name: string; icon?: string; path: string }[] = [];
}
